import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { HerracContext } from "./App"; // 👈 Contextdən istifadəçi alırıq

function PrivateAdminRoute() {
  const { user } = useContext(HerracContext);


  if (!user) {
    // 🔥 Giriş etməyibsə, SignIn səhifəsinə yönləndir
    return <Navigate to="/giris" replace />;
  }

  if (user.role !== "Admin") {
    // 🔥 İstifadəçi admin deyilsə, error səhifəsinə yönləndir
    return <Navigate to="/" replace />;
  }

  // ✅ Əgər admin isə, daxil olmağa icazə ver
  return <Outlet />;
}

export default PrivateAdminRoute;
